import { Flex, Loader } from '@mantine/core';
import { lazy, Suspense, useState } from 'react';
import { getPreloadedAnalysisWorkspace, preloadAnalysisWorkspace } from './analysisWorkspaceChunk';

const LazyAnalysisWorkspacePage = lazy(() =>
	preloadAnalysisWorkspace().then((page) => ({ default: page }))
);

/** A preloaded chunk renders directly; a cold deep link suspends inside the page area, keeping the app chrome. */
export const AnalysisWorkspaceRoute = () => {
	// Read once per mount, so the tree never swaps between the two branches.
	const [PreloadedPage] = useState(getPreloadedAnalysisWorkspace);

	if (PreloadedPage) {
		return <PreloadedPage />;
	}
	return (
		<Suspense
			fallback={
				<Flex flex={1} align="center" justify="center" h="100%">
					<Loader size="sm" />
				</Flex>
			}
		>
			<LazyAnalysisWorkspacePage />
		</Suspense>
	);
};
